export default {"src":"/_next/static/media/icon-check-circled.be2cc9f5.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};